// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bcbf1de1","239":"1e04ba7b","453":"05a6e3a5","455":"48f419b5","483":"b0e75780","909":"3f3bbe8f"}[chunkId] + ".chunk.js";
};